var ExtractMap = /** @class */ (function () {
    function ExtractMap() {
        this.fieldCallbacks = {};
        this.fields = [{
                key: 'microchip_number',
                validation: function () { },
                transform: function (value) {
                    return value.replace(/\D/g, '');
                },
            }, {
                key: 'pet_breed',
                validation: function () { },
            }, {
                key: 'pet_name',
                validation: function () { },
            }, {
                key: 'gender',
                validation: function (value) {
                    return ["male", "female"].includes(value.toLowerCase());
                },
                transform: function (value) {
                    return value.toLowerCase();
                }
            }, {
                key: 'date_of_birth',
                validation: validateDate,
            }, {
                key: 'vaccination_date',
                validation: validateDate,
            }, {
                key: 'pet_color',
                validation: null,
            }, {
                key: 'owner_name',
                validation: function () { },
            }, {
                key: 'addresses',
                validation: function () { },
            }, {
                key: 'telephone',
                validation: function () { },
                transform: function (value) {
                    value = value.replace(/^\+44/g, '');
                    value = value.replace(/\D/g, '');
                    value = value.replace(/^0+/g, '');
                    value = value.substring(0, 10);
                    value = "+44" + value;
                    return value;
                },
            }, {
                key: 'email',
                validation: function () { },
            }, {
                key: 'vaccination_batch',
                validation: function () { },
            }, {
                key: 'vaccine_brand',
                validation: function (value) {
                    var matches = value.match(/canigen|rabisin|purevax|nobivac|zoetis/i);
                    return matches ? matches[0] : null;
                },
                // transform: (value) => {
                //     let matches = value.match(/canigen|rabisin|purevax|nobivac|zoetis/i);
                //     return matches ? matches[0] : null;
                // }
            }];
        this.options = null;
        this.onFieldsChange = null;
        this.onOptionsChange = null;
        this.selected = 0;
    }
    ExtractMap.prototype.setOptions = function (options) {
        this.options = options;
        this.onOptionsChange && this.onOptionsChange();
    };
    ExtractMap.prototype.setFields = function (fields) {
        this.fields = fields;
        this.onFieldsChange && this.onFieldsChange();
    };
    ExtractMap.prototype.setFieldCallbacks = function (fieldCallbacks) {
        this.fieldCallbacks = fieldCallbacks;
        this.onFieldsChange && this.onFieldsChange();
    };
    ExtractMap.prototype.setOnFieldsChange = function (callback) {
        this.onFieldsChange = callback;
        if (this.fields) {
            this.onFieldsChange && this.onFieldsChange();
        }
    };
    ExtractMap.prototype.setOnOptionsChange = function (callback) {
        this.onOptionsChange = callback;
        if (this.options) {
            this.onOptionsChange && this.onOptionsChange();
        }
    };
    ExtractMap.prototype.getFields = function (entitiesByType, doc) {
        var _a;
        if (!this.fields) {
            return [];
        }
        (_a = this.fields) === null || _a === void 0 ? void 0 : _a.forEach(function (field) {
            var _a;
            field.values = [];
            (_a = entitiesByType[field.key]) === null || _a === void 0 ? void 0 : _a.forEach(function (entity) {
                var _a, _b;
                if ((_a = entity.normalizedValue) === null || _a === void 0 ? void 0 : _a.text) {
                    var value = (_b = entity.normalizedValue) === null || _b === void 0 ? void 0 : _b.text;
                    if (field.transform) {
                        value = field.transform(value);
                    }
                    field.values.push(value);
                }
                else {
                    var value = doc.text.substring(entity.textAnchor.textSegments[0].startIndex, entity.textAnchor.textSegments[0].endIndex);
                    value = value.trim();
                    if (field.transform) {
                        value = field.transform(value);
                    }
                    if (field.validate && field.validate(value) === false) {
                        return;
                    }
                    if (value) {
                        field.values.push(value);
                    }
                }
            });
            console.log('field.values', field.values);
        });
        // this.fields?.filter((field) => {
        //     return field.values && field.values.length > 0;
        // });
        return this.fields;
    };
    return ExtractMap;
}());
export function validateDate(value) {
    var date = new Date(value);
    return date instanceof Date && !isNaN(date.getTime());
}
var extractMap = new ExtractMap();
export default extractMap;
